import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { scrollX } from '@finect/tabular-utils/scrollX';
export var FiltersContainer = styled.div.withConfig({
  displayName: "Containers__FiltersContainer",
  componentId: "sc-13xf1k7-0"
})(["display:inline-flex;flex-shrink:1;> button{white-space:nowrap;}", ";"], maxMediaQueries.desktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: inline-flex;\n    width: 100%;\n\n    ", "\n\n    > div {\n      position: static;\n      flex-shrink: 0;\n    }\n  "])), function (_ref) {
  var _ref$scrollable = _ref.scrollable,
    scrollable = _ref$scrollable === void 0 ? false : _ref$scrollable;
  return scrollable ? scrollX : '';
}));
export var SortsContainer = styled.div.withConfig({
  displayName: "Containers__SortsContainer",
  componentId: "sc-13xf1k7-1"
})(["display:flex;flex-shrink:0;margin-left:auto;"]);